"use strict";

var _pubsubJs = require("pubsub-js");

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

var _countdown = require("@bva/countdown");

var _countdown2 = _interopRequireDefault(_countdown);

var _themeA11y = require("@shopify/theme-a11y");

var _Helpers = require("common/Helpers");

var _WindowsVariantSelect = require("components/WindowsVariantSelect");

var _WindowsVariantSelect2 = _interopRequireDefault(_WindowsVariantSelect);

var _CollectionPositioner = require("components/CollectionPositioner");

var _CollectionPositioner2 = _interopRequireDefault(_CollectionPositioner);

var _InlineCart = require("components/InlineCart");

var _InlineCart2 = _interopRequireDefault(_InlineCart);

var _WindowsHeader = require("components/WindowsHeader");

var _WindowsHeader2 = _interopRequireDefault(_WindowsHeader);

var _WindowsFooter = require("components/WindowsFooter");

var _WindowsFooter2 = _interopRequireDefault(_WindowsFooter);

var _PassEvent = require("components/PassEvent");

var _PassEvent2 = _interopRequireDefault(_PassEvent);

var _LineItem = require("components/LineItem");

var _LineItem2 = _interopRequireDefault(_LineItem);

var _FeelingLucky = require("components/FeelingLucky");

var _FeelingLucky2 = _interopRequireDefault(_FeelingLucky);

var _HeaderCountdown = require("components/HeaderCountdown");

var _HeaderCountdown2 = _interopRequireDefault(_HeaderCountdown);

var _IOLazyLoad = require("components/IOLazyLoad");

var _IOLazyLoad2 = _interopRequireDefault(_IOLazyLoad);

var _ProductTiles = require("../sections/ProductTiles");

var _ProductTiles2 = _interopRequireDefault(_ProductTiles);

var _CountrySelector = require("components/CountrySelector");

var _CountrySelector2 = _interopRequireDefault(_CountrySelector);

var _DataLayer = require("components/DataLayer");

var _DataLayer2 = _interopRequireDefault(_DataLayer);

var _state = require("state");

var _state2 = _interopRequireDefault(_state);

require("styles/theme.scss");

require("styles/theme.scss.liquid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_pubsubJs2.default.immediateExceptions = true;

// Common a11y fixes


// import Toggle from 'components/Toggle';
// import Overlay from 'components/Overlay';
// import CartControls from 'components/CartControls';
// import QuantitySelect from 'components/QuantitySelect';


// import "lazysizes";
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

_InlineCart2.default.initSubscribers();
_WindowsHeader2.default.initSubscribers();
_WindowsVariantSelect2.default.initSubscribers();
_CollectionPositioner2.default.setup();

document.addEventListener("DOMContentLoaded", function () {
  _WindowsVariantSelect2.default.bindActions();
  _LineItem2.default.setup();
  _FeelingLucky2.default.setup();
  _InlineCart2.default.bindActions();
  _InlineCart2.default.fetchInlineCart();
  _WindowsHeader2.default.bindActions();
  _WindowsFooter2.default.bindActions();
  // any countdown timers
  (0, _Helpers.setTimerCountdownInfo)();
  _countdown2.default.setup({});
  // setup passing events
  _PassEvent2.default.setup('hover');
  _HeaderCountdown2.default.setup();
  _IOLazyLoad2.default.setupObservers();
  _ProductTiles2.default.setupProductTileGroups();
  _CountrySelector2.default.setup();
  _DataLayer2.default.setup();

  ajaxCart.init({
    formSelector: '#AddToCartForm',
    cartContainer: '#CartContainer',
    addToCartSelector: '#AddToCart',
    enableQtySelectors: true,
    moneyFormat: theme.strings.moneyFormat
  });

  (0, _Helpers.setHeaderContentHeight)();
});

// On window resize, set the spacing above the body for the sticky header
var resizeDebouncer = (0, _Helpers.debounce)(function () {
  (0, _Helpers.setHeaderContentHeight)();
}, 300);
window.addEventListener('resize', resizeDebouncer);

// HMR
if (module.hot) {
  module.hot.accept();
}

if (module.hot) {
  module.hot.dispose(function () {
    // reset/undo the behavior/side effect that as possibly enabled/enacted
  });
}

$(function () {
  $('body').on('click', '.variant-selector__list--pdp li.variant-selector__item', function () {
    var pdp_BIS_input = document.querySelector('input#BIS-email-input');
    $('li.variant-selector__item').removeClass('variant-selected');
    $(this).addClass('variant-selected');

    if (pdp_BIS_input === null) return;
    pdp_BIS_input.setAttribute('data-product-id', $(this).data('product-id'));
    pdp_BIS_input.setAttribute('data-variant-id', $(this).data('id'));
  });

  $('body').on('click', 'button.BIS-btn', function () {
    var email = $('input#BIS-email-input').val(),
        productId = $('input#BIS-email-input').data('product-id'),
        variantId = $('input#BIS-email-input').data('variant-id');
    var promise = BIS.create(email, variantId, productId);

    promise.then(function (data) {
      var BISsuccess = document.querySelector('#BIS_success_msg');
      var BISerror = document.querySelector('#BIS_error_msg');
      if (data.status == 'OK') {
        var success = data.message;
        BISsuccess.textContent = success;
        BISsuccess.style.display = 'inline';
        $('.BIS_main-section').hide();
        BISerror.style.display = 'none';
      } else {
        var errors = '';
        for (var k in data.errors) {
          errors = data.errors[k];
        }

        if (errors[0] == 'Specify either an email address or a phone number') {
          BISerror.textContent = 'Please Specify An Email Address';
        } else {
          BISerror.textContent = errors;
        }

        BISerror.style.display = 'inline';
      }
    });
  });

  $('body').on('click', '.quickshop-modal li.variant-selector__item', function () {
    var plp_BIS_input = document.querySelector('input#BIS-email-input');

    $('.quickshop-modal li.variant-selector__item').removeClass('variant-selected');
    $(this).addClass('variant-selected');
    plp_BIS_input.setAttribute('data-product-id', $(this).data('base-product'));
    plp_BIS_input.setAttribute('data-variant-id', $(this).data('id'));

    if ($(this).data('available')) {
      $('.BIS_pdp-section').addClass('hidden');
      $('.quickshop-modal .quickshop__atc').removeClass('hidden');
    } else {
      $('.BIS_pdp-section').removeClass('hidden');
      $('.quickshop-modal .quickshop__atc').addClass('hidden');
    }
  });
});